<script setup lang="ts">
import { computed } from "vue";

import SVGWrapper from "./utils/SVGWrapper.vue";

import type { colorTag } from "@/Modules/App/Models/Styles/Colors";
import type { iconSize } from "@/Modules/App/Models/Styles/Icons";

export interface IconProps {
  size?: iconSize;
  color?: colorTag;
  background?: colorTag;
}

const props = withDefaults(defineProps<IconProps>(), { color: "content-high", size: "md" });

const colorClass = computed((): string => `fill-${props.color}`);
</script>

<template>
  <SVGWrapper :size="size" :background="background" viewBox="0 0 20 13">
    <g clip-path="url(#clip0_6892_8978)">
      <path
        d="M19.7258 6.09877C18.2923 2.44993 14.4871 0 10.2649 0C6.04267 0 2.26352 2.44993 0.803987 6.09877C0.751861 6.22908 0.751861 6.38546 0.803987 6.51578C2.23746 10.1646 6.04267 12.6145 10.2649 12.6145C14.4871 12.6145 18.2923 10.1646 19.7258 6.51578C19.7779 6.38546 19.7779 6.22908 19.7258 6.09877ZM10.2649 11.4938C6.59 11.4938 3.25392 9.40878 1.9247 6.30727C3.27998 3.20576 6.59 1.12071 10.2649 1.12071C13.9398 1.12071 17.2759 3.20576 18.6051 6.30727C17.2759 9.40878 13.9659 11.4938 10.2649 11.4938ZM10.2649 2.24143C8.02347 2.24143 6.19905 4.06584 6.19905 6.30727C6.19905 8.5487 8.02347 10.3731 10.2649 10.3731C12.5063 10.3731 14.3307 8.5487 14.3307 6.30727C14.3307 4.06584 12.5063 2.24143 10.2649 2.24143ZM10.2649 9.2524C8.64898 9.2524 7.31976 7.92318 7.31976 6.30727C7.31976 4.69136 8.64898 3.36214 10.2649 3.36214C11.8808 3.36214 13.21 4.69136 13.21 6.30727C13.21 7.92318 11.8808 9.2524 10.2649 9.2524ZM10.2649 4.79561C9.43087 4.79561 8.75323 5.47325 8.75323 6.30727C8.75323 7.14129 9.43087 7.81893 10.2649 7.81893C11.0989 7.81893 11.7766 7.14129 11.7766 6.30727C11.7766 5.47325 11.0989 4.79561 10.2649 4.79561Z"
        :class="colorClass"
      />
    </g>
    <defs>
      <clipPath id="clip0_6892_8978">
        <rect width="19" height="12.6145" fill="white" transform="translate(0.777832)" />
      </clipPath>
    </defs>
  </SVGWrapper>
</template>

<style scoped lang="scss"></style>
